// TODO-FUTURE Similar code is used in the reports service, move to a common location
export const answerNumberToLetter = (answerNumber: number): string => {
  if (answerNumber < 1) {
    console.error('Invalid answer number provided', answerNumber);
    answerNumber = 1;
  }
  const prefixBase = 64;
  const alphaBase = 26;

  let remainder = answerNumber % alphaBase;
  if (remainder === 0) {
    remainder = alphaBase;
  }

  let prefix = String.fromCharCode(prefixBase + remainder);

  if (answerNumber > alphaBase) {
    let secondOrder = Math.floor(answerNumber / alphaBase);
    if (answerNumber % alphaBase === 0) {
      // Subtract one if it evenly divides
      secondOrder -= 1;
    }
    prefix = String.fromCharCode(prefixBase + secondOrder) + prefix;
  }

  return prefix;
};
